<template>
  <div class="notice-page">
    <div class="notice-container">
      <!-- 标题区域 -->
      <header class="notice-header">
        <h1>关于湖北省数字版权综合服务平台<br>开通数据增值服务付费业务的通知</h1>
      </header>

      <!-- 正文内容 -->
      <section class="notice-body">
        <div class="meta-info">
          <span>尊敬的各位平台用户、合作单位：</span>
        </div>
        <p class="intro-text">
          为持续优化湖北省数字版权综合服务平台（以下简称“平台”）服务功能、提升平台运营质量、保障系统稳定运维与技术迭代升级，为广大用户提供更专业、高效、安全的数字化服务支撑，经统筹规划、审慎研究，平台自即日起开通数据增值服务付费业务。现将相关事宜通知如下：
        </p>

        <!-- 一、收费项目及标准 -->
        <div class="section">
          <h2 class="section-title">一、收费项目及标准</h2>
          <div class="table-wrapper">
            <table class="fee-table">
              <thead>
                <tr>
                  <th>服务项目</th>
                  <th>办理时限</th>
                  <th>收费</th>
                  <th>备注</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="4">版权登记<br>（电子证书）</td>
                  <td>15个工作日</td>
                  <td>19元/件</td>
                  <td></td>
                </tr>
                <tr>
                  <td>5个工作日</td>
                  <td>49元/件</td>
                  <td></td>
                </tr>
                <tr>
                  <td>3个工作日</td>
                  <td>99元/件</td>
                  <td></td>
                </tr>
                <tr>
                  <td>1个工作日</td>
                  <td>199元/件</td>
                  <td></td>
                </tr>
                <tr>
                  <td>专有许可备案</td>
                  <td>15个工作日</td>
                  <td>50元/件</td>
                  <td></td>
                </tr>
                <tr>
                  <td>转让合同备案</td>
                  <td>15个工作日</td>
                  <td>50元/件</td>
                  <td></td>
                </tr>
                <tr>
                  <td>纸质证书打印</td>
                  <td>3-5个工作日</td>
                  <td>5元/张</td>
                  <td>邮寄费自理</td>
                </tr>
                <tr>
                  <td>信息变更</td>
                  <td>3-5个工作日</td>
                  <td>50元/件</td>
                  <td>邮寄费自理</td>
                </tr>
                <tr>
                  <td>证书撤销</td>
                  <td>3-5个工作日</td>
                  <td>50元/件</td>
                  <td>邮寄费自理</td>
                </tr>
                <tr>
                  <td>版权存证</td>
                  <td>即时</td>
                  <td>5元/件</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 二、服务升级保障 -->
        <div class="section">
          <h2 class="section-title">二、服务升级保障</h2>
          <p>
            平台将全面升级服务体系：持续优化系统稳定性、修复功能漏洞、迭代新增实用功能；开通专属客服通道、技术运维专线，保障用户问题快速响应、高效解决；建立常态化服务回访机制，根据用户需求持续优化服务体验，全力为用户提供高品质、标准化的服务支撑。
          </p>
        </div>

        <!-- 三、合作与风险提示 -->
        <div class="section">
          <h2 class="section-title">三、合作与风险提示</h2>
          <p>为规范平台收费运营秩序、保障全体用户合法权益，杜绝违规代理、虚假收费等风险问题，现就平台代理合作及相关风险事宜郑重提示如下：</p>
          
          <div class="sub-section">
            <h3>1. 代理合作规范</h3>
            <p>平台所有代理合作、渠道授权、套餐代办服务，仅由平台认证的正规合作机构及专属客户经理负责开展，所有授权代理机构信息将在平台备案。任何单位或个人未经平台授权，不得以本平台代理商、合作方名义开展收费代缴、套餐代办、优惠充值、功能开通等相关业务。</p>
          </div>

          <div class="sub-section">
            <h3>2. 严禁违规代办</h3>
            <p>平台员工不会私自向用户收取平台服务费用、代办平台业务、售卖平台套餐及增值服务。用户所有缴费、充值、套餐办理、功能开通操作，仅可通过平台官网、官方对公账户、官方客服渠道办理。任何私下转账、第三方代办、私下交易行为，均与平台无关，平台不承担任何资金损失、权益失效、服务异常等相关责任。</p>
          </div>

          <div class="sub-section">
            <h3>3. 合规收费风险警示</h3>
            <p>平台严格遵守国家网络交易收费相关合规规定，坚决杜绝重复收费、强制消费、变相涨价、转嫁费用等违规行为，所有收费项目、计费标准、服务内容公开透明、有据可依。任何代理及合作主体不得强制、变相强制用户购买套餐服务，不得擅自更改收费标准、增设隐形收费项目，不得克扣用户套餐权益、篡改计费数据，一经发现违规，平台将立即终止合作权限，并依法追究其相关责任。</p>
          </div>

          <div class="sub-section">
            <h3>4. 诈骗风险防范提示</h3>
            <p>请广大用户提高警惕，切勿轻信非官方渠道的收费、优惠、代办信息，不随意添加陌生联系人、不进行私下资金交易。如遇可疑人员冒充平台代理、客服人员，以“低价续费、内部名额、故障补费、套餐升级”等为由诱导用户私下转账的诈骗行为，请立即通过平台官方渠道核实并举报，切实保障自身财产与账号安全。</p>
          </div>

          <div class="sub-section">
            <h3>5. 违规追责说明</h3>
            <p>对于未经授权私自开展平台代理收费业务、虚假宣传、违规牟利、损害平台及用户权益的单位或个人，平台将永久禁止合作、公示违规名单，并保留通过法律途径追究其全部责任的权利，全力维护平台正常运营秩序与用户合法权益。</p>
          </div>
        </div>

        <!-- 四、业务合作与咨询 -->
        <div class="section">
          <h2 class="section-title">四、业务合作与咨询</h2>
          <ul class="contact-list">
            <li><strong>客服热线：</strong>027-8763 6698（工作日 9:00-17:30）；</li>
            <li><strong>客服邮箱：</strong>453118328@qq.com ；</li>
            <li><strong>线下对接：</strong>企业用户可联系专属客服一对一咨询办理。</li>
          </ul>
        </div>

        <!-- 结尾致谢 -->
        <div class="closing">
          <p>感谢各位用户长期以来对平台的信任、支持与陪伴。平台将以此为新起点，坚守服务初心、精进服务品质，为广大用户创造更高价值的服务体验。</p>
          <p>特此通知。</p>
        </div>

        <div class="signature">
          <p>湖北省数字版权综合服务平台</p>
          <p>2026 年 7 月 1 日</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyrightServiceNotice',
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.notice-page {
  display: flex;
  justify-content: center;
  background-color: #f5f7fa;
  padding: 30px 16px;
  font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
}

.notice-container {
  max-width: 1128px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 50px;
}

@media (max-width: 640px) {
  .notice-container {
    padding: 24px 18px;
  }
}

.notice-header {
  text-align: center;
  border-bottom: 2px solid #e8edf3;
  padding-bottom: 20px;
  margin-bottom: 28px;
}

.notice-header h1 {
  font-size: 26px;
  font-weight: 700;
  color: #1a2a3a;
  letter-spacing: 1px;
  line-height: 1.4;
  margin-bottom: 12px;
}

.meta-info {
  font-size: 16px;
  line-height: 1.8;
  color: #1f2a36;
}

.intro-text {
  font-size: 16px;
  line-height: 1.8;
  color: #1f2a36;
  margin-bottom: 28px;
  text-indent: 2em;
}

.section {
  margin-top: 30px;
}

.section p{
  text-indent: 2em;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #0b1e2e;
  border-left: 5px solid #2c6b9e;
  padding-left: 14px;
  margin-bottom: 18px;
  line-height: 1.4;
}

.table-wrapper {
  margin: 12px 0 18px;
}

.fee-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
  min-width: 480px;
  border: 1px solid #cdd9e8;
}

.fee-table th,
.fee-table td {
  padding: 12px 10px;
  text-align: center;
  border: 1px solid #cdd9e8;
  color: #1f2e3e;
}

.fee-table th {
  background-color: #f0f5fd;
  color: #1a2a3a;
  font-weight: 600;
  padding: 14px 12px;
}

.fee-table td:last-child {
  color: #4d6278;
  font-size: 14px;
}

.fee-table tbody tr:hover {
  background-color: #f6faff;
}

p {
  font-size: 16px;
  line-height: 1.8;
  color: #1f2a36;
  margin-bottom: 12px;
  text-align: justify;
}

.sub-section {
  margin: 18px 0 16px;
  padding-left: 8px;
}

.sub-section h3 {
  font-size: 17px;
  font-weight: 600;
  color: #1f3a57;
  margin-bottom: 6px;
}

.sub-section p {
  margin-bottom: 6px;
  padding-left: 4px;
}

.contact-list {
  list-style: none;
  padding: 0;
  margin: 8px 0 4px;
  background: #f9fcff;
  border-radius: 10px;
  padding: 16px 22px;
}

.contact-list li {
  font-size: 16px;
  line-height: 2;
  color: #1f2a36;
}

.contact-list li strong {
  color: #0b2b4a;
  font-weight: 600;
  margin-right: 4px;
}

.closing {
  margin-top: 34px;
  padding-top: 16px;
}

.closing p {
  text-indent: 2em;
  margin-bottom: 6px;
}

.signature {
  margin-top: 30px;
  text-align: right;
  font-weight: 500;
  color: #1a2a3a;
  font-size: 17px;
  line-height: 1.8;
  padding-top: 24px;
}
.signature p{
  text-align: right;
}

.signature p:last-child {
  font-weight: 400;
  color: #3f5568;
}

@media (max-width: 480px) {
  .notice-header h1 {
    font-size: 20px;
  }
  .fee-table {
    font-size: 14px;
    min-width: 360px;
  }
  .fee-table th,
  .fee-table td {
    padding: 10px 6px;
  }
  .section-title {
    font-size: 18px;
  }
}
</style>